var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_254_7860)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3526 0C13.3526 4.28733 16.7784 7.76266 21.0047 7.76266C16.7784 7.76266 13.3526 11.238 13.3526 15.5253C13.3526 11.238 9.92672 7.76266 5.70044 7.76266C9.92672 7.76266 13.3526 4.28733 13.3526 0Z",
    fill: "#FF2247"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_254_7860",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 17,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3526 0C13.3526 4.28733 16.7784 7.76266 21.0047 7.76266C16.7784 7.76266 13.3526 11.238 13.3526 15.5253C13.3526 11.238 9.92672 7.76266 5.70044 7.76266C9.92672 7.76266 13.3526 4.28733 13.3526 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_254_7860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0061 0H17.9443V15.5268H21.0061V0Z",
    fill: "#FF2247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9443 0H14.8826V15.5268H17.9443V0Z",
    fill: "#FF2247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8841 0H11.8224V15.5268H14.8841V0Z",
    fill: "#FF2247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8223 0H8.76062V15.5268H11.8223V0Z",
    fill: "#FF2247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76058 0H5.69885V15.5268H8.76058V0Z",
    fill: "#FF2247"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1747 10.8611C20.1747 13.0055 21.8876 14.7432 24.0015 14.7432C21.8876 14.7432 20.1747 16.4808 20.1747 18.6252C20.1747 16.4808 18.4618 14.7432 16.3479 14.7432C18.4618 14.7432 20.1747 13.0055 20.1747 10.8611Z",
    fill: "#FF2247"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_254_7860",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 10,
    width: 9,
    height: 9
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1747 10.8611C20.1747 13.0055 21.8876 14.7432 24.0015 14.7432C21.8876 14.7432 20.1747 16.4808 20.1747 18.6252C20.1747 16.4808 18.4618 14.7432 16.3479 14.7432C18.4618 14.7432 20.1747 13.0055 20.1747 10.8611Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_254_7860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 10.8611H22.4698V18.6237H24V10.8611Z",
    fill: "#B367FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4698 10.8611H20.9397V18.6237H22.4698V10.8611Z",
    fill: "#B367FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9398 10.8611H19.4097V18.6237H20.9398V10.8611Z",
    fill: "#B367FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4082 10.8611H17.8781V18.6237H19.4082V10.8611Z",
    fill: "#B367FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.878 10.8611H16.3479V18.6237H17.878V10.8611Z",
    fill: "#B367FF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5539 17.1179C14.5539 18.1901 15.4104 19.059 16.4673 19.059C15.4104 19.059 14.5539 19.9278 14.5539 21C14.5539 19.9278 13.6974 19.059 12.6405 19.059C13.6974 19.059 14.5539 18.1901 14.5539 17.1179Z",
    fill: "#D0A0FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_254_7860",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 17,
    width: 5,
    height: 4
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5539 17.1179C14.5539 18.1901 15.4104 19.059 16.4673 19.059C15.4104 19.059 14.5539 19.9278 14.5539 21C14.5539 19.9278 13.6974 19.059 12.6405 19.059C13.6974 19.059 14.5539 18.1901 14.5539 17.1179Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_254_7860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4673 17.1179H15.7023V21H16.4673V17.1179Z",
    fill: "#D0A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7022 17.1179H14.9371V21H15.7022V17.1179Z",
    fill: "#D0A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9372 17.1179H14.1721V21H14.9372V17.1179Z",
    fill: "#D0A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1706 17.1179H13.4055V21H14.1706V17.1179Z",
    fill: "#D0A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4056 17.1179H12.6405V21H13.4056V17.1179Z",
    fill: "#D0A0FF"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66704 19.222V19.9966H0V19.222H0.866777C1.02893 19.222 1.14686 19.1756 1.22204 19.0814C1.29722 18.9872 1.33407 18.8466 1.33407 18.6582V12.4463C1.33407 12.2594 1.29574 12.1173 1.22204 12.0246C1.14686 11.9304 1.02746 11.884 0.866777 11.884H0V11.1094H3.53934V12.7813H3.62631C4.0199 12.2414 4.49014 11.7988 5.03999 11.4534C5.58983 11.1079 6.21633 10.9344 6.92242 10.9344C7.83637 10.9344 8.53805 11.1991 9.0304 11.727C9.52128 12.2549 9.76746 13.0116 9.76746 13.997V18.6777C9.76746 18.8661 9.80726 19.0037 9.88834 19.0919C9.96941 19.1801 10.0844 19.2235 10.2348 19.2235H11.1192V19.9981H6.45218V19.2235H7.04183C7.19219 19.2235 7.30717 19.1771 7.38824 19.0829C7.46932 18.9887 7.50912 18.8481 7.50912 18.6597V13.6965C7.50912 13.1925 7.38972 12.8052 7.15386 12.5345C6.91653 12.2654 6.56127 12.1293 6.0866 12.1293C5.56624 12.1293 5.09453 12.3117 4.67293 12.6751C4.24986 13.0385 3.8946 13.4841 3.60568 14.012V18.6582C3.60568 18.8466 3.64548 18.9872 3.72655 19.0814C3.80763 19.1756 3.92261 19.222 4.07297 19.222H4.66261H4.66704Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_7860"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H17C20.866 0 24 3.13401 24 7V21H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/headerLogo.1eca22f2644414fa2052f72ff4025afc.svg";
export { ForwardRef as ReactComponent };